/** Preset ids and titles compiled from the platform manifest at build time (see build.mjs). */
export interface LandingPreset {
  readonly id: string;
  readonly title: string;
}
declare const __CDR_PRESETS__: LandingPreset[];
export const landingPresets: readonly LandingPreset[] = __CDR_PRESETS__;
